<div class="preferences-flyout">
    @if (isLoading$ | async) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    <div class="preferences-title-container">
        <span class="preferences-title">Notification Preferences</span>
        <button class="nova__button--icon" mat-dialog-close>
            <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
        </button>
    </div>
    <div class="preferences-help-container">
        <span class="preferences-help">Select your Nova In-App Preferences:</span>
    </div>
    <ng-container [ngTemplateOutlet]="allPreferences">
    </ng-container>
</div>


<ng-template #taskPreferences>
    <div class="preferences-title-container">
        <span class="preferences-title">Tasks assigned to me have been:</span>
    </div>
    <div class="preferences-help-container">
        <span class="preferences-help italic">You will always receive a Nova In-App Notification when you're assigned a
            task or when your task assignment is overdue.</span>
    </div>
    @for (assignedToMePreference of preferences['TasksAssignedToMe']; track assignedToMePreference.id) {
        <div class="preferences-help-container preferences-toggle-container">
            <span>{{assignedToMePreference.title}}</span>
            <span>
                <mat-slide-toggle matTooltip="{{ assignedToMePreference.isEnabled ? 'Disable' : 'Enable' }}"
                    matTooltipPosition="after" [checked]="assignedToMePreference.isEnabled"
                    (change)="togglePreferenceEnabled(assignedToMePreference)">
                </mat-slide-toggle>
            </span>
        </div>
    }
    <div class="preferences-title-container">
        <span class="preferences-title">Tasks created by me have been:</span>
    </div>
    @for (createdByMePreference of preferences['TasksCreatedByMe']; track createdByMePreference.id) {
        <div class="preferences-help-container preferences-toggle-container">
            <span>{{createdByMePreference.title}}</span>
            <span>
                <mat-slide-toggle matTooltip="{{ createdByMePreference.isEnabled ? 'Disable' : 'Enable' }}"
                    matTooltipPosition="after" [checked]="createdByMePreference.isEnabled"
                    (change)="togglePreferenceEnabled(createdByMePreference)">
                </mat-slide-toggle>
            </span>
        </div>
    }
</ng-template>

<ng-template #ticketPreferences>
    <mat-expansion-panel class="nova__expansion" [expanded]="ticketsOpen" (opened)="onPanelOpened('Tickets')">
        <mat-expansion-panel-header class="nova__expansion__header">
            <mat-panel-title>Tickets</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <div class="preferences-title-container">
                <span class="preferences-title">Tickets assigned to me have been:</span>
            </div>
            <div class="preferences-help-container">
                <span class="preferences-help italic">You will always receive a Nova In-App Notification when you're
                    assigned a ticket.</span>
            </div>
            <div class="preferences-help-container preferences-toggle-container"></div>
            <div class="preferences-title-container">
                <span class="preferences-title">Tickets created by me have been:</span>
            </div>
            <div class="preferences-help-container preferences-toggle-container"></div>
        </ng-template>
    </mat-expansion-panel>
</ng-template>

<ng-template #jobPreferences>
    <mat-expansion-panel class="nova__expansion" [expanded]="jobsOpen" (opened)="onPanelOpened('Jobs')">
        <mat-expansion-panel-header class="nova__expansion__header">
            <mat-panel-title>Jobs</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <div class="preferences-title-container">
                <span class="preferences-title">Action Items assigned to my Job(s)</span>
            </div>
            <div class="preferences-help-container">
                <span class="preferences-help italic">You will always receive a Nova In-App Notification when an action item have
                    been added to one of your job(s).
                </span>
            </div>
            @for (assignedToMePreference of preferences['ActionsAssignedToMe']; track assignedToMePreference.id) {
                <div class="preferences-help-container preferences-toggle-container">
                    <span>{{assignedToMePreference.title}}</span>
                    <span>
                        <mat-slide-toggle matTooltip="{{ assignedToMePreference.isEnabled ? 'Disable' : 'Enable' }}"
                            matTooltipPosition="after" [checked]="assignedToMePreference.isEnabled"
                            (change)="togglePreferenceEnabled(assignedToMePreference)">
                        </mat-slide-toggle>
                    </span>
                </div>
            }
            <div class="preferences-title-container">
                <span class="preferences-title">Action Items created by me have been:</span>
            </div>
            @for (createdByMePreference of preferences['ActionsCreatedByMe']; track createdByMePreference.id) {
                <div class="preferences-help-container preferences-toggle-container">
                    <span>{{createdByMePreference.title}}</span>
                    <span>
                        <mat-slide-toggle matTooltip="{{ createdByMePreference.isEnabled ? 'Disable' : 'Enable' }}"
                            matTooltipPosition="after" [checked]="createdByMePreference.isEnabled"
                            (change)="togglePreferenceEnabled(createdByMePreference)">
                        </mat-slide-toggle>
                    </span>
                </div>
            }
        </ng-template>
    </mat-expansion-panel>
</ng-template>


<ng-template #allPreferences>
    <div class="preferences-panel-container">
        <mat-expansion-panel class="nova__expansion" [expanded]="tasksOpen" (opened)="onPanelOpened('Tasks')">
            <mat-expansion-panel-header class="nova__expansion__header">
                <mat-panel-title>Tasks</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <ng-container *ngTemplateOutlet="taskPreferences"></ng-container>
            </ng-template>
        </mat-expansion-panel>

        @if (enableInAppNotificationsTickets) {
            <ng-container *ngTemplateOutlet="ticketPreferences"></ng-container>            
        }

        <ng-container *ngTemplateOutlet="jobPreferences"></ng-container>
    </div>
</ng-template>
